import React from "react";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { FormikProps } from "formik";
const index = ({
  FormikProps,
  name,
}: {
  FormikProps: FormikProps<any>;
  name: string;
}) => {
  return (
    <InputOTP
      maxLength={4}
      dir="rtl"
      onChange={(value) => {
        FormikProps.setFieldValue(name, value);
      }}
    >
      <InputOTPSlot index={0} />
      <InputOTPSlot index={1} />
      <InputOTPSlot index={2} />
      <InputOTPSlot index={3} />
      {/* <InputOTPSlot index={4} />
      <InputOTPSlot index={5} /> */}
    </InputOTP>
  );
};

export default index;
